<template>
  <div class="animated fadeIn accelerator-requests">
    <!-- loading component -->
    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 border-0" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="dark">
            <h5 class="mb-0" style="display: inline-block">
              عنوان و حمایت‌های پیشین
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-1"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text class="p-3">
              <ul>
                <li>
                  <strong class="c-purple">عنوان پایان‌نامه ارشد: </strong>
                  {{ proposal.faSubject }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ ثبت پروپوزال: </strong
                  >{{ proposal.dateProposalSubmission }}
                </li>

                <li>
                  <strong class="c-purple"
                    >عنوان پروژه کارشناسی (در صورت وجود):
                  </strong>
                  {{
                    proposal.bachelorProjectSubject
                      ? proposal.bachelorProjectSubject
                      : "فاقد پروژه کارشناسی"
                  }}
                </li>

                <li>
                  <strong class="c-purple"
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟</strong
                  >
                  <b-form-radio-group
                    v-model="proposal.initialIsSupported"
                    disabled
                  >
                    <b-form-radio :value="true">بله</b-form-radio>
                    <b-form-radio :value="false">خیر</b-form-radio>
                  </b-form-radio-group>
                </li>

                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">حمایت ها: </strong
                  >{{
                    options.filter(
                      (x) => x.value == proposal.initialSupportedType
                    )[0].text
                  }}
                </li>
                <li
                  v-if="
                    proposal.initialSupportedType == 'other' &&
                    proposal.initialIsSupported
                  "
                >
                  <strong class="c-purple">عنوان حمایت دریافتی: </strong
                  >{{ proposal.initialOtherSupport }}
                </li>
                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">توضیحات حمایت دریافتی: </strong
                  >{{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-2 variant="light">
            <h5 class="mb-0" style="display: inline-block">
              اطلاعات اصلی پایان‌نامه ارشد
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <ul>
                <li>
                  <strong class="c-purple">عنوان به زبان فارسی: </strong
                  >{{ proposal.faSubject }}
                </li>
                <li>
                  <strong class="c-purple">عنوان به زبان انگلیسی: </strong
                  >{{ proposal.enSubject }}
                </li>
                <li>
                  <strong class="c-purple"
                    >دانشگاه محل اجرای پایان‌نامه ارشد :
                  </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.universityId == notUniversity">
                  <strong class="c-purple">نام دانشگاه: </strong
                  >{{ proposal.otherUniversity }}
                </li>
                <li v-if="proposal.mehvarId != notMehvar">
                  <strong class="c-purple">محور پایان‌نامه ارشد : </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple"> محور پایان‌نامه ارشد</strong>
                  : سایر محورها
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple">نام محور: </strong
                  >{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong class="c-purple">ماهیت پایان‌نامه ارشد: </strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.typeStudy"
                      >مطالعاتی</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="proposal.typeSystemicDevelopmental"
                      >سیستمی و توسعه‌ای</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.typePractical"
                      >کاربردی</b-form-checkbox
                    >
                  </b-form-group>
                </li>
                <li>
                  <strong class="c-purple">حوزه پایان‌نامه ارشد: </strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.zoneMedicine"
                      >پزشکی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneAgriculture"
                      >کشاورزی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneEnvironment"
                      >محیط زیست</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneIndustrial"
                      >صنعتی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneBioComputing"
                      >رایانش زیستی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneOther"
                      >سایر</b-form-checkbox
                    >
                  </b-form-group>
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-3 variant="warning">
            <h5 class="mb-0" style="display: inline-block">اطلاعات دانشجو</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <ul>
                <li>
                  <strong class="c-purple">نام: </strong
                  >{{ proposal.researcherName }}
                </li>
                <li>
                  <strong class="c-purple">نام خانوادگی: </strong
                  >{{ proposal.researcherLastName }}
                </li>
                <li>
                  <strong class="c-purple">کدملی: </strong
                  >{{ proposal.researcherNatCode }}
                </li>
                <li>
                  <strong class="c-purple">تلفن همراه: </strong
                  >{{ proposal.researcherMobile }}
                </li>
                <li>
                  <strong class="c-purple">دورنگار: </strong
                  >{{ proposal.researcherFax }}
                </li>
                <li>
                  <strong class="c-purple">پست الکترونیکی: </strong
                  >{{ proposal.researcherEmail }}
                </li>
                <li>
                  <strong class="c-purple">استان: </strong
                  >{{ proposal.researcherState }}
                </li>
                <li>
                  <strong class="c-purple">شهر: </strong
                  >{{ proposal.researcherCity }}
                </li>

                <li>
                  <strong class="c-purple">دانشگاه محل تحصیل: </strong>
                  {{
                    universities.filter(
                      (x) => x.id == proposal.researcherUniversityId
                    ).length
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0].text
                        : "---"
                      : "---"
                  }}
                </li>
                <li v-if="proposal.researcherUniversityId == notUniversity">
                  <strong class="c-purple">نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityOther }}
                </li>
                <li>
                  <strong class="c-purple">شماره دانشجویی: </strong
                  >{{ proposal.researcherStudentNumber }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-4 variant="info">
            <h5 class="mb-0 text-white" style="display: inline-block">
              اساتید پایان‌نامه ارشد
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <span class="h5"
                >تعداد اساتید پایان‌نامه ارشد :
                {{ proposal.teachers.length }}</span
              >
              <hr />
              <b-card
                class="mt-3 border-0 px-2"
                v-for="(prof, index) in proposal.teachers"
                :key="index"
                header-bg-variant="info"
              >
                <template v-slot:header>
                  <strong class="c-purple">استاد شماره {{ index + 1 }}</strong>
                </template>
                <ul>
                  <li>
                    <strong class="c-purple">نام: </strong>{{ prof.name }}
                  </li>
                  <li>
                    <strong class="c-purple">نام خانوادگی: </strong
                    >{{ prof.lastName }}
                  </li>
                  <li>
                    <strong class="c-purple">کدملی:</strong>{{ prof.natCode }}
                  </li>
                  <li>
                    <strong class="c-purple">نقش استاد در پایان‌نامه:</strong>
                    {{ prof.role == "supervisor" ? "مشاور" : "راهنما" }}
                  </li>
                  <li>
                    <strong class="c-purple">تلفن همراه: </strong
                    >{{ prof.mobile }}
                  </li>
                  <li>
                    <strong class="c-purple">پست الکترونیکی: </strong
                    >{{ prof.email }}
                  </li>
                  <li>
                    <strong class="c-purple">سمت: </strong>{{ prof.position }}
                  </li>
                  <li>
                    <strong class="c-purple">دانشگاه محل تحصیل: </strong
                    >{{
                      universities.filter((x) => x.id == prof.universityId)
                        .length
                        ? universities.filter(
                            (x) => x.id == prof.universityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == prof.universityId
                            )[0].text
                          : "---"
                        : "---"
                    }}
                  </li>
                  <li v-if="prof.universityId == notUniversity">
                    <strong class="c-purple">نام دانشگاه: </strong
                    >{{ prof.universityOther }}
                  </li>
                  <li>
                    <strong class="c-purple"
                      >دانشگاه محل اشتغال به عنوان عضوهئیت علمی:
                    </strong>
                    {{
                      universities.filter((x) => x.id == prof.universityJobId)
                        .length
                        ? universities.filter(
                            (x) => x.id == prof.universityJobId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == prof.universityJobId
                            )[0].text
                          : "---"
                        : "---"
                    }}
                  </li>
                  <li v-if="prof.universityJobId == notUniversity">
                    <strong class="c-purple">نام دانشگاه: </strong
                    >{{ prof.universityJobOther }}
                  </li>
                  <li>
                    <strong class="c-purple">آخرین مدرک تحصیلی: </strong
                    >{{ prof.lastDegree }}
                  </li>
                  <li>
                    <strong class="c-purple">رزومه استاد: </strong>
                    <a
                      v-if="prof.resumeFile"
                      :href="prof.resumeFile"
                      target="blank"
                      >دانلود</a
                    >
                    <span v-else>--</span>
                  </li>
                </ul>
              </b-card>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-5 variant="info">
            <h5 class="mb-0 text-white" style="display: inline-block">
              اطلاعات پروپوزال
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <ul>
                <li>
                  <strong class="c-purple">بیان مساله: </strong
                  >{{ proposal.problemStatement }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">ضرورت تحقیق: </strong
                  >{{ proposal.requestNecessity }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"> سوالات تحقیق (اصلی/فرعی): </strong
                  >{{ proposal.researchQuestions }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"> فرضیات تحقیق (اصلی/فرعی): </strong
                  >{{
                    proposal.researchHypotheses
                      ? proposal.researchHypotheses
                      : "-"
                  }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">اهداف تحقیق(اصلی/فرعی): </strong
                  >{{ proposal.majorGoals }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">روش کلی تحقیق: </strong
                  >{{ proposal.generalResearchMethod }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"> قلمرو مکانی تحقیق: </strong
                  >{{ proposal.spatialScopeResearch }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"> قلمرو زمانی تحقیق: </strong
                  >{{ proposal.researchTimeDomain }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">
                    روش نمونه گیری و تعیین حجم نمونه: </strong
                  >{{ proposal.researchSampling }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">
                    روش گرد آوری داده ها و ابزار: </strong
                  >{{ proposal.dataCollectionMethod }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"> روش های تحلیل داده ها: </strong
                  >{{ proposal.analysisMethod }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"> موانع و محدودیت های تحقیق: </strong
                  >{{ proposal.researchObstacles }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple"> چارچوب کلان نظری تحقیق: </strong
                  >{{ proposal.researchMacroTheoreticalFramework }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">شرح واژه ها و اصطلاحات: </strong
                  >{{ proposal.keywords }}
                </li>
                <hr />
                <li>
                  <strong class="c-purple">فهرست منابع: </strong
                  >{{ proposal.references }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-7 variant="light">
            <h5 class="mb-0" style="display: inline-block">
              زمان‌بندی و فازبندی پایان‌نامه ارشد
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <p class="mb-1">
                <strong class="c-purple">زمان شروع:</strong>
                {{
                  proposal.gantData.length > 0
                    ? moment(
                        new Date(
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )
                        )
                      ).format("jYYYY/jMM/jDD")
                    : ""
                }}
              </p>

              <p class="mb-1">
                <strong class="c-purple">زمان پایان:</strong>
                {{
                  proposal.gantData.length > 0
                    ? moment(
                        new Date(
                          Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )
                        )
                      ).format("jYYYY/jMM/jDD")
                    : ""
                }}
              </p>
              <p>
                <strong class="c-purple">مدت زمان:</strong>
                {{
                  proposal.gantData.length > 0
                    ? (Math.max(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dueDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      ) -
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )) /
                        3600 /
                        24 /
                        1000 +
                      " روز"
                    : ""
                }}
              </p>

              <div>
                <sarmadGantt
                  :items="proposal.gantData"
                  :fields="serviceFields"
                />
              </div>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-8 variant="dark">
                <h5 class="mb-0" style="display: inline-block">فایل‌های تکمیلی ({{step7progress}})%</h5>
                <b-icon
                  icon="pencil-square"
                  font-scale="2"
                  aria-hidden="true"
                  style="float:left"
                  @click="tabIndex=7"
                ></b-icon>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <li>
                    نامه شورای پژوهش یا فناوری دانشگاه
                    :
                    <b-button variant="primary">
                      <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                    </b-button>
                  </li>
                  <li>
                    صورت جلسه دفاع پروپوزال بصورت رسمی و با سربرگ دانشگاه
                    :
                    <b-button variant="primary">
                      <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                    </b-button>
                  </li>
                  <li>
                    فایل پروپوزال(Word):
                    <b-button variant="primary">
                      <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                    </b-button>
                  </li>
                  <li>
                    فایل پروپوزال(pdf):
                    <b-button variant="primary">
                      <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                    </b-button>
                  </li>
                  <li>
                    ارائه نامه رسمی جهت اعلام شماره حساب محل اجرای پایان‌نامه ارشد:
                    <b-button variant="primary">
                      <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                    </b-button>
                  </li>
                  <li>
                    نامه شرکت دانش بنیان:
                    <b-button variant="primary">
                      <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                    </b-button>
                  </li>
                  <li>
                    سایر مدارک
                    :
                    <b-button variant="primary"></b-button>
                  </li>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card> -->

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-8 variant="dark">
            <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <b-form-group disabled>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                  >درج عبارت زیر در پایان‌نامه و کلیه انتشارات،مقالات،سخنرانی
                  ها،اسلایدها و مانند آن انجام خواهد گرفت<br />
                  '' این پژوهش با کمک مالی شماره ....... ستاد توسعه زیست فناوری
                  انجام شده است''<br />
                  ''This study was financially supported bygrant NO:.... of the
                  Biotechnology Development Council of the Islamic Republic of
                  Iran''<br />
                  در صورت عدم درج،حمایت مرحله دوم صورت نخواهد گرفت.
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                  >توافق بین دانشجو و صنعت برای بهره برداری از نتایج پایان‌نامه
                  وجود دارد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >نحوه تجاری سازی پایان‌نامه مشخص است و مستندات ارائه شده
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >فایل نهایی پایان‌نامه،دستاوردها،ثبت اختراعات و مقالات پس از
                  اتمام پایان‌نامه بارگذاری می شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[4]"
                  >دعوتنامه جهت حضور در جلسه دفاع به حضور کارشناس گروه پژوهش
                  خواهد رسید.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[5]"
                  >ثبت اطلاعات تعهدی برای حمایت نداشته و به منزله ثبت درخواست
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[6]"
                  >پذیرفته شدن در بخش اول تعهدی برای حمایت از بخش دوم ایجاد نمی
                  کند و مدارک و اقدامات مربوط به بخش دوم در سامانه قابل ثبت و
                  بررسی خواهد بود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[7]"
                  >کلیه موارد فوق مورد تایید اینجانب
                  {{
                    proposal.researcherName + " " + proposal.researcherLastName
                  }}
                  می باشد.</b-form-checkbox
                >
              </b-form-group>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection
const sarmadGantt = () => import("./../components/sarmadGantt");
import Select2 from "v-select2-component";
export default {
  props: ["proposal", "universities", "mehvars", "companies"],
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gant chart
  },
  data() {
    return {
      moment: moment,
      fileBusy: true,
      acc: 0,
      pageLoaded: false,
      isLoaded: false,
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "title", label: "عنوان فایل" },
        // { key: "description", label: "توضیحات" },
        { key: "url", label: "دریافت" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      uploadedFiles: [],
      fileFilter: "",
      tabIndex: 0,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
    };
  },
  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
  },
};
</script>

<style></style>
